import { ExternalLink } from 'lucide-react'
import { useTranslation } from 'react-i18next'

import { Badge } from '@/components/ui/badge'
import { getTagadaTpaDashboardUrl } from '@/lib/tagadapay-dashboard'
import { tpaStatusMeta } from '@/lib/tagadapay-tpa-status'
import { cn } from '@/lib/utils'

export type TpaLiveStatusProps = {
    tpaId?: string | null
    status?: string | null
    mode?: string | null
    compact?: boolean
    interactive?: boolean
    className?: string
}

export const TpaLiveStatus = ({
    tpaId,
    status,
    mode,
    compact = false,
    interactive = true,
    className,
}: TpaLiveStatusProps) => {
    const { t } = useTranslation('processors')

    if (!tpaId) return null

    const meta = tpaStatusMeta(status)
    const chips = (
        <>
            <Badge variant={meta.variant} className="px-1.5 py-0 text-[10px] leading-4">
                {t(meta.labelKey)}
            </Badge>
            {mode === 'test' && (
                <Badge variant="outline" className="px-1.5 py-0 text-[10px] leading-4">
                    {t('tagadapayRouter.accountTestBadge')}
                </Badge>
            )}
            <span className={cn('font-mono', compact ? 'text-[10px]' : 'text-xs')}>{tpaId}</span>
        </>
    )

    if (!interactive) {
        return (
            <span className={cn('inline-flex max-w-full items-center gap-1.5', className)}>
                {chips}
            </span>
        )
    }

    return (
        <a
            href={getTagadaTpaDashboardUrl(tpaId)}
            target="_blank"
            rel="noopener noreferrer"
            onClick={(e) => e.stopPropagation()}
            title={t('tagadapayRouter.openDashboard')}
            className={cn(
                'inline-flex max-w-full items-center gap-1.5 no-underline',
                'text-muted-foreground hover:text-foreground',
                className,
            )}
        >
            {chips}
            <ExternalLink className={compact ? 'size-3' : 'size-3.5'} />
        </a>
    )
}
